import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleAboutClick = () => {
    setIsMenuOpen(false);
    if (location.pathname === '/') {
      const element = document.getElementById('despre-noi');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      navigate('/', { state: { scrollTo: 'despre-noi' } });
    }
  };

  const handleHomeClick = (e) => {
    setIsMenuOpen(false);
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <div className="logo-text">
              <span className="logo-eka">EKA</span>
              <span className="logo-company">COMPANY</span>
            </div>
          </Link>
          
          <button 
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
            <Link to="/" onClick={handleHomeClick}>Acasă</Link>
            <button type="button" onClick={handleAboutClick}>Despre Noi</button>
            <Link to="/projects" onClick={() => setIsMenuOpen(false)}>Proiecte</Link>
            <Link to="/services" onClick={() => setIsMenuOpen(false)}>Servicii</Link>
            <Link to="/portfolio" onClick={() => setIsMenuOpen(false)}>Portofoliu</Link>
            <Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;

